export enum UserCompanyRole {
  LEAD = 'lead',
  MEMBER = 'member',
}
